import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { loginAD } from "../../apis";
import { startFinalLogin } from '../../store/auth/authThunks';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';

const AuthCallback = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const code = urlParams.get('code');

        if (!code) {
          throw new Error('No se recibió código de autorización');
        } else {

          const result = await loginAD(code);

          if (result && result.data) {
            // El correo viene en la respuesta del canje. Antes se guardaba la
            // cadena "not-given", y varias pantallas leen Session.email para
            // saber quién es el usuario (perfil, testigos, usuarios del reporte).
            const email = result.data.email ?? "";
            const { domain_list } = result.data;
            // El caché de react-query se guarda en localStorage y sus llaves no
            // llevan el tenant: lo que quedó de una sesión anterior (otro
            // tenant) se vería en la nueva.
            queryClient.clear();
            if (Array.isArray(domain_list) && domain_list.length > 1) {
              // Con varios dominios se pregunta a cuál entrar, igual que en el
              // login con contraseña: la sesión queda sin tenant y /login
              // muestra el selector con la lista que llega en el state.
              dispatch(startFinalLogin(email, result, null, true));
              navigate('/login', { replace: true, state: { domainList: domain_list } });
            } else {
              dispatch(startFinalLogin(email, result));
              navigate('/');
            }
          } else {
            // Si no hay datos, considerarlo como un error
            throw new Error('No se recibieron datos de autenticación');
          }

        }
      } catch (error) {
        console.error("Error durante la autenticación:", error);
        // Redirigir al usuario a la página de login en caso de cualquier error
        navigate('/');
      }
    };

    handleCallback();
  }, [location, navigate, dispatch, queryClient]);

  return <div>working...</div>;
};

export default AuthCallback;
